import React, { ChangeEvent } from 'react';

type Props = {
  fileUploaderRef: { current: HTMLInputElement };
  handleFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  allowMultipleUploads: boolean;
};

const FileUploader = ({ fileUploaderRef, handleFileInputChange, allowMultipleUploads }: Props) => {
  return (
    <input
      style={{ display: 'none' }}
      type="file"
      ref={fileUploaderRef}
      onChange={handleFileInputChange}
      value=""
      multiple={allowMultipleUploads}
    />
  );
};

export default FileUploader;
